import { BottomLeftFeedback } from '../ActionSuccessToast'
import { X } from 'lucide-react'

export default function IdeaRemovalToast({ notice, onDismiss }) {
  if (!notice) return null
  return (
    <BottomLeftFeedback>
    <div
      data-testid="idea-removal-toast"
      role={notice.tone === 'error' ? 'alert' : 'status'}
      className={`max-w-[calc(100vw-2.5rem)] transition-[opacity,transform] duration-[250ms] ease-out motion-reduce:transition-none ${notice.fading ? 'pointer-events-none translate-y-2 opacity-0' : 'translate-y-0 opacity-100'}`}
    >
      <div className={`animate-notification-toast-in flex items-center gap-4 rounded-lg border bg-canvas px-4 py-3 text-xs shadow-xl ${notice.tone === 'error' ? 'border-ember/35 text-ember' : 'border-border text-ink'}`}>
        <span>{notice.text}</span>
        {notice.undo && <button type="button" disabled={notice.fading} onClick={notice.undo} className="rounded px-1 py-0.5 font-semibold underline underline-offset-2 hover:bg-canvas2">Undo</button>}
        {notice.tone === 'error' && <button type="button" aria-label="Dismiss idea removal error" onClick={onDismiss} className="rounded p-1 hover:bg-canvas2"><X size={12} /></button>}
      </div>
    </div>
    </BottomLeftFeedback>
  )
}
